import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import MintImage from '../../assets/6.png'; // Use a different name for the imported image
import Miner from '../Icons/miner.png';
import threedgif from '../../components/Icons/3dmodel.gif';
import styled from 'styled-components';
import zombie from '../../components/Icons/zombie.png';
import tokenbound from '../../components/Icons/ddddaaaaddd.png';
import nirvan from '../../components/Icons/nirvan.png';
import timecapsule from '../../components/Icons/timecapsule.png';
import govern from '../../components/Icons/govern.png';
import group from '../../components/Icons/group.png';
import coming from '../../components/Icons/coming.jpg';
import people from '../../assets/Nfts/people.png';
import rocl from '../../assets/Nfts/chibigif.gif';
const CustomCarousel = styled(Carousel)`
  .carousel .control-prev.control-arrow,
  .carousel .control-next.control-arrow {
    background-color: rgba(255, 255, 255, 0.8); // Background color for arrows
    background-opacity: 0.8; // Increased opacity for better visibility
    box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.5); // Shadow for depth
    &:hover {
      transform: scale(1.1); // Scale up on hover for attention
      transition: transform 0.3s ease-in-out;
    }
  }

  .carousel .control-prev.control-arrow:before {
    color: black; // Color of arrow
    border-right: 35px solid black; // Slightly larger arrow
  }

  .carousel .control-next.control-arrow:before {
    color: black; // Color of arrow

    border-left: 35px solid black; 
  }
`;



const MainHeader = styled.h2`
  text-align: center;
  font-size: 4em;
  color: black;
  font-weight: 1000;
  font-family: 'Akaya Telivigala', cursive;

  &:hover {
      transform: scale(1.1); // Scale up on hover for attention
      transition: transform 0.3s ease-in-out;
    }

  @media (max-width: 48em) { // Adjust for medium devices
    font-size: 4em; // Adjust font size
  }
  @media (max-width: 30em) { // Adjust for small devices
    font-size: 3em; // Adjust font size
  }
`;

const SlideContainer = styled.div`
  display: flex;
 
    
  
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  margin: 0px;
`;

const Card = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid #ddd;
  border-radius: 8px;
  margin: 10px;
  flex: 0 0 calc(33.333% - 20px);
  max-width: calc(33.333% - 20px);
  height: 700px; // Fixed height for image

  &:hover {
    transform: scale(1.01); // Scale up on hover for attention
    transition: transform 0.3s ease-in-out;
    box-shadow: 10px 12px 11px rgba(0, 0, 0, 0.7);

  }




  @media (max-width: 48em) {
    flex: 0 0 calc(50% - 20px);
    max-width: calc(50% - 20px);
  }
  @media (max-width: 30em) {
    flex: 0 0 calc(100% - 20px);
    max-width: calc(100% - 20px);
  }
`;

const CardImage = styled.img`
 background-color: #f8f8f8; // Background color for card content
  border-radius: 8px;
  border-bottom: 1px solid #ddd;
  height: 400px; // Fixed height for image
  object-fit: fill;
  flex-shrink: 0; // Image won't shrink
`;

const CardContent = styled.div`
  padding: 15px;
  background-color: #f8f8f8; // Background color for card content
  flex-grow: 1; // Content will fill the rest of the space
`;


const CardTitle = styled.h3`
  margin: 0;
  color: #333;
`;

const CardDescription = styled.p`
  color: #666;
  height: 130px; 
border-bottom: 2px solid #ddd;

`;

const CardButton = styled.a`
  display: inline-block;
font-family: 'Akaya Telivigala', cursive;
  border-radius: 4px;
  text-align: center;
  text-decoration: none;
  margin-top: 30px;

 display: inline-block;
  background-color: black;
  color: white;
  outline: none;
  border: none;
bottom: 10px;
  font-size: 24px;
  padding: 0.9rem 2.3rem;
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  &:hover {
    transform: scale(0.9);
    
  }

  &::after {
    content: " ";
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%) scale(0);
    border: 2px solid black;
    width: 100%;
    height: 100%;
    border-radius: 50px;
    transition: all 0.2s ease;
  }

  &:hover::after {
    transform: translate(-50%, -50%) scale(1);
    padding: 0.3rem;
  }
`;
// Dummy DApps array
const dummyDapps = [
    // Repeat this structure 12 times with different titles, images, and descriptions
    { id: 1, title: 'Psycho-Chibi Mint Dapp', image: MintImage, description: '15% revenue share, rewards will accrue as the mint goes on, every NFT minted the Rewards are dispersed to holders according to how many nfts they own and then claimable via our dapp! Holders who hold multiple NFTs will receive a higher percentage of the rewards! There is also a refferal system built into allowing you to earn more sgb rewards by referring to others. Every NFT minted using your refferal code (wallet address) you will get 350 SGB sent directly to your wallet.', link: 'https://pyscho-chibi-mint-dapp.vercel.app/' },
    { id: 2, title: 'Psycho Soft Mining', image: Miner, description: 'Here you can stake your NFTs trustlessly via (Soft-Staking) meaning your NFTS never leave your wallet! And earn Psycho Gem Rewards! Psycho gems will be used to mint by traits via our upcoming Chibi factory DApp future NFTs, evolve nfts, open loot boxes, and will be used in Nirvanis Metaverse!', link: 'https://nirvanis-soft-staking.vercel.app', isUnderConstruction: true  },
    { id: 3, title: '3D Modeled/Animated NFTs ', image: threedgif, description: 'Here you can mint 3D animated NFTs! Each NFT will be a 3D model and will be able to be used as a playable character in the Nirvanis Immersive Metaverse! ', link: '#', isUnderConstruction: true },
    { id: 4, title: 'Zombie Evolution Dapp', image: zombie, description: 'Here you can evolve your NFTs to the next level of Pyscho Zombies! Each NFT is evolved using psycho gems. $PSYGEMs will be burned as the Psycho chibi eats the gems.', link: '#', isUnderConstruction: true },
    { id: 5, title: 'Token Bound Dapp', image: tokenbound, description: 'ERC-6551 enables Token Bound Accounts (TBAs). These are smart contracts that have their own address and are associated/managed with a specific NFT. Think of it as a mini-wallet that is directly tied to the NFT, opening up possibilities such as: NFTs can store assets (as compared to your wallet holding your assets)', link: '#', isUnderConstruction: true },
    { id: 6, title: 'Nirvanis Metaverse', image: nirvan, description: 'Our Metaverse is being built using react.js, javascript, and three.js. We are currently building it out! Nirvanis will be a 3D Immersive world world where you can explore around a immersive enviorment and see differnet visually please things! As well as interact with other holders, play games, and explore!', link: '#', isUnderConstruction: true },
    { id: 7, title: 'Time Capsule DApp', image: timecapsule, description: 'A decentralized application that allows users to create and store digital time capsules with messages, images, and videos that can be opened at a future date.', link: '#', isUnderConstruction: true },
    { id: 8, title: 'Governance DApp', image: govern, description: 'A blockchain-based governance platform that enables transparent decision-making and voting for amongst Nirvanis community members.', link: '#', isUnderConstruction: true },
    { id: 9, title: 'NFT Marketplace DApp', image: group, description: 'A decentralized multichain marketplace for buying and selling unique digital assets, such as art, collectibles.', link: '#', isUnderConstruction: true },
    { id: 10, title: 'People of Flare Community Canvas', image: people, description: 'This Dapp is a unique never before been made Flare community Canvas, allowing users to mint their spot on the canvas for 1 dollar and upload their image to it. Once the canvas is full it will be auction on our in house auction dapp, proceeds will get dispersed to all those who have a spot on the canvas', link: '#', isUnderConstruction: true },
    { id: 11, title: 'Chibi Factory', image: rocl, description: 'Our State of the Art Chibi Factory will allow user to customize their own chibis! By buying Traits with Psycho Gem tokens, merging them into one single NFT! ', link: '#', isUnderConstruction: true },
    { id: 12, title: 'Coming Soon', image: coming, description: 'The Community will be able to Vote for what kind of DApp they would like to see', link: '#', isUnderConstruction: true },
  ];

  
const InstructionBanner = styled.div`
  text-align: center;
  background-color: rgba(255, 255, 255, 0.8);
  color: #333;
  padding: 10px;
  border-radius: 5px;
  margin-bottom: 20px;
`;
  

const Section = styled.section`
  width: 100vw;
  position: relative;

`;

  const VaultDapp = () => {
      // Function to chunk the array of dapps into groups of 6
      const chunkArray = (arr, size) =>
        arr.length ? [arr.slice(0, size), ...chunkArray(arr.slice(size), size)] : [];
    
      const dappGroups = chunkArray(dummyDapps, 6);
    
      return (
        <>
        <Section id="vaultdapp">
              <MainHeader>DApp Vault</MainHeader>
              <InstructionBanner>
  Swipe left or right to explore different DApps. Click on a "Visit DApp" for more information!
</InstructionBanner>
              <CustomCarousel showThumbs={false} showStatus={false} infiniteLoop useKeyboardArrows   preventMovementUntilSwipeScrollTolerance={true} and swipeScrollTolerance={50} // Adjust this value as needed
>
          {dappGroups.map((group, index) => (
            <SlideContainer key={index}>
              {group.map(dapp => (
                <Card key={dapp.id}>
  <CardImage src={dapp.image} alt={dapp.title} />
  <CardContent>
    <CardTitle>{dapp.title}</CardTitle>
    <CardDescription>{dapp.description}</CardDescription>
    {!dapp.isUnderConstruction ? (
      <CardButton href={dapp.link} target="_blank">Visit DApp</CardButton>
    ) : (
      <CardButton as="div">Under Construction</CardButton> // Render as a div or another element
    )}
  </CardContent>
</Card>
              ))}
            </SlideContainer>
          ))}
        </CustomCarousel>
        </Section>
        </>
      );
    }
    
    export default VaultDapp;